import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DiagramJsonHandlerService} from '../../../diagram-data/diagram-json-handler.service';
import {environment} from '../../../../environments/environment';
import {NoteAttachmentsDaoService} from '@q9elements/ui-kit/attachments';
import {handleError, NoteAttachment} from '@q9elements/ui-kit/common';

@Injectable({
  providedIn: 'root'
})
export class DiagramNoteAttachmentsService extends NoteAttachmentsDaoService {
  private diagramJsonSvc = inject(DiagramJsonHandlerService);
  private get diagram() {
    return this.diagramJsonSvc.get();
  }
  public url: string = '';
  public noteAttachment: NoteAttachment;

  public setBaseUrl() {} // TODO remove after fix it in ui-kit

  override populateAttachment(attachment: NoteAttachment): Observable<any> {
    this.url = [
      `${environment.API_ENDPOINT}/diagram/`,
      `${this.diagram.diagramId}/state/`,
      `${this.diagram.state}/${attachment.cellId}/attachment/`,
      `${attachment._id}/populateNoteContent`
    ].join('');

    return this.http.get(this.url).pipe(handleError());
  }
}
